export type CaseType = {
  id: number;
  status_name: string;
  color_idx: number | null;
  closed_at: string| null;
  mos: string;
  submission_source: string | null;
  user_id: number | null;
  admin_user_id: number;
  creator_name: string;
  creator_ip: string | null;
  created_at: string;
  received_at: string;
  investigated_at: string;
  buy_and_bill: boolean;
  state: string  | null;
  active: boolean;
  hidden: boolean;
  doctor_firstlastname: string | null;
  doctor_fullname: string;
  patient_firstlastname: string | null;
  patient_fullname: string | null;
  patient_dob: string;
  practice_name: string;
  drug_id: number;
  drug_name: string;
  tat: string | null;
  category: string;
  external_id : string;
  received_date: string | null;
  status_reason: string | null;
  priority: string | null;
  urgency: string | null;
  missing_info_checkbox: boolean;
  missing_info_text: string | null;
  time_lapsed: string | null;
  patient: {
    id: number;
    firstlastname: string;
  };
  doctor: {
    id: number;
    firstlastname: string;
  };
  treatment: {
    id: number,
    scheduled_at: string
  };
};

export interface PatientTitleProps {
  readonly value: string;
  readonly label: string;
};

export type PrescriptionObjKeyProps = 
  "drug_name" |
  "direction" |
  "quickstart" |
  "cp_diuretics" |
  // "cp_diuretics" |
  // "cp_diuretics.diuretics_tried.furosemide_props" |
  // "cp_diuretics.diuretics_tried.furosemide" |
  // "cp_diuretics.diuretics_tried.torsemide_props" |
  // "cp_diuretics.diuretics_tried.torsemide" |
  // "cp_diuretics.diuretics_tried.bumetanide_props" |
  // "cp_diuretics.diuretics_tried.bumetanide" |
  "condition" |
  "diagnosis_code" |
  "injection_site" |
  "review_type" |
  "note" |
  "scheduled_date_of_service" |
  "written_date";

export const PATIENT_DETAIL_CASE = [
  {
    value: '',
    label: 'Case ID',
  },
  {
    value: '',
    label: 'Created',
  },
  {
    value: '',
    label: 'Treated',
  },
  {
    value: '',
    label: 'Provider',
  },
  {
    value: '',
    label: 'Status',
  },
  {
    value: '',
    label: 'Not Treated Reason',
  },
  // {
  //   value: '',
  //   label: 'Indication',
  // },
  // {
  //   value: '',
  //   label: 'Sales Rep Note',
  // },
];

export const REFILL_DATA_LISTING = [
  {value:"",label:"Dispense Date"},
  {value:"shipment_type",label:"Shipment Type"},
  {value:"",label:"Prescriber Last Name"},
  {value:"",label:"Prescriber First Name"},
  {value:"",label:"Rx Qty"},
  {value:"",label:"Refills"},
  {value:"",label:"Patient ID"},
  {value:"",label:"Fill Number"},
  {value:"",label:"Rx Number"},
]
